import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './style.css';
import { applyTheme, readStoredTheme } from './lib/theme';
import { installGuillemetsAutoreplace } from './lib/guillemets';

applyTheme(readStoredTheme());
installGuillemetsAutoreplace();
createApp(App).use(createPinia()).mount('#app');

if ('serviceWorker' in navigator && (location.protocol === 'https:' || location.hostname === 'localhost')) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js'); });
}
